import { CardWrapper } from './card-wrapper';
import { Alert, Heading, Text } from '@restworld/ui-ds-base';
import { useAtomValue } from 'jotai';
import { workerPresentationTextAtom } from '../global-state.worker-data';
import { WorkerDataLoader } from './worker-data-loader';
import { useProfileCommonIntl } from './hooks';
import { useFetchWorkerDataLoading } from '../../hooks';

export const PresentationSection = () => {
  const workerDataLoading = useFetchWorkerDataLoading();
  const presentationData = useAtomValue(workerPresentationTextAtom);
  const { isWorkerPresentationInfoMissing: isInformationMissing } = useIsWorkerPresentationInfoMissing();
  const { missingInfo: errorMessage, missingInfoText, translate: t } = useProfileCommonIntl();

  return (
    <CardWrapper title={t('common:presentation')} editPageType="presentation">
      <div id="presentation" className="flex flex-col items-start justify-start pt-6">
        {isInformationMissing && !workerDataLoading && <Alert text={missingInfoText} className="mb-4" />}
        {workerDataLoading && <WorkerDataLoader />}
        {!workerDataLoading && (
          <>
            <Heading size={5} weight="medium" className="mb-2">
              {t('common:cover_letter')}
            </Heading>
            <Text color={presentationData?.presentation_text ? 'muted' : 'error'} align="left" className="mb-4">
              {presentationData?.presentation_text || errorMessage}
            </Text>
            <Heading size={5} weight="medium" className="mb-2">
              {t('onboarding-page:why_are_you_looking_for_work')}
            </Heading>
            <Text color={presentationData?.motivation_text ? 'muted' : 'error'} align="left" className="mb-4">
              {presentationData?.motivation_text || errorMessage}
            </Text>
          </>
        )}
      </div>
    </CardWrapper>
  );
};

export function useIsWorkerPresentationInfoMissing() {
  const presentationData = useAtomValue(workerPresentationTextAtom);
  const isWorkerPresentationInfoMissing = !presentationData?.motivation_text || !presentationData?.presentation_text;

  return { isWorkerPresentationInfoMissing };
}
